import { render, staticRenderFns } from "./ImageButtonDuplicate.vue?vue&type=template&id=56dde73c&scoped=true&"
import script from "./ImageButtonDuplicate.vue?vue&type=script&lang=js&"
export * from "./ImageButtonDuplicate.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/sass/style_custom.scss?vue&type=style&index=0&id=56dde73c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56dde73c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/WebClient/WebClient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56dde73c')) {
      api.createRecord('56dde73c', component.options)
    } else {
      api.reload('56dde73c', component.options)
    }
    module.hot.accept("./ImageButtonDuplicate.vue?vue&type=template&id=56dde73c&scoped=true&", function () {
      api.rerender('56dde73c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Forms/Buttons/ImageButtonDuplicate.vue"
export default component.exports